import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/questionnaire/questionnaire.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-71c5bae6")

_pushScopeId("data-v-71c5bae6")
const _hoisted_1 = { class: "questionnaire-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    class: "header-top-banner",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "questionnaire-body" }
const _hoisted_4 = { class: "questionnaire-body__main" }
const _hoisted_5 = { style: {"color":"#7453d5"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 给 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 成员创建调查问卷")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 调查问卷 ")
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { style: {"text-indent":"2em","text-align":"left"} }, null, -1)
const _hoisted_10 = { class: "member-reason-item__title" }
const _hoisted_11 = {
  key: 1,
  class: "member-reason-item__title prefix-mark-item"
}
const _hoisted_12 = { class: "member-reason-item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "member-reason-item__title prefix-mark-item" }, [
  /*#__PURE__*/_createVNode("span", null, "其他")
], -1)
const _hoisted_14 = {
  key: 0,
  style: {"margin":"16px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 提交 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_divider = _resolveComponent("van-divider")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_checkbox = _resolveComponent("van-checkbox")
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_form = _resolveComponent("van-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", null, [
          _createVNode("h4", _hoisted_5, [
            (!_ctx.onlyReadable)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  _createVNode("span", null, _toDisplayString(_ctx.userInfo.userName), 1),
                  _hoisted_7,
                  _createVNode(_component_van_icon, {
                    name: "question-o",
                    size: "40",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$dialog.alert({
                                message: '如需给指定成员录入调查问卷，请在 “健康” 页面顶部进行切换为指定的成员后，再进入此页面后成员名称会自动调整！',
                                theme: 'round-button',confirmButtonText: '关闭',confirmButtonColor: 'rgb(159, 102, 204)',messageAlign: 'left'
                                })), ["stop"]))
                  })
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_8
                ], 64))
          ]),
          _hoisted_9
        ]),
        _createVNode(_component_van_divider, {
          dashed: "",
          style: {"border-color":"#adbbcf"}
        }),
        _createVNode(_component_van_form, {
          onSubmit: _ctx.submitMemberQuestionnaireSave,
          ref: "form"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "member-reason-item"
              }, [
                (item._isChild)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_van_divider, { dashed: "" }),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("span", {
                          textContent: _toDisplayString(item.title + item.appendTitle)
                        }, null, 8, ["textContent"])
                      ])
                    ], 64))
                  : (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("span", {
                        textContent: _toDisplayString(item.title + item.appendTitle)
                      }, null, 8, ["textContent"])
                    ])),
                _createVNode(_component_van_field, {
                  name: item.name,
                  rules: [{required: true, message: ('请至少选择一项' + item.title), trigger: 'onSubmit' }]
                }, {
                  input: _withId(() => [
                    _createVNode(_component_van_checkbox_group, {
                      disabled: _ctx.onlyReadable,
                      modelValue: item.selectedValueItems,
                      "onUpdate:modelValue": ($event: any) => (item.selectedValueItems = $event),
                      direction: "horizontal",
                      "checked-color": "#4850c4",
                      onChange: selectedValue => _ctx.handlerSelectChnage(selectedValue, item.selectItems, item, _ctx.list, index)
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.selectItems, (selectItem, selectIndex) => {
                          return (_openBlock(), _createBlock(_component_van_checkbox, {
                            key: selectIndex,
                            name: selectItem.value,
                            shape: "square"
                          }, {
                            icon: _withId(({checked, disabled}) => [
                              checked
                                ? (_openBlock(), _createBlock(_component_van_button, {
                                    key: 0,
                                    size: "small",
                                    disabled: _ctx.onlyReadable || disabled,
                                    round: "",
                                    color: "#7232dd"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(selectItem.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled"]))
                                : (_openBlock(), _createBlock(_component_van_button, {
                                    key: 1,
                                    size: "small",
                                    disabled: _ctx.onlyReadable || disabled,
                                    round: "",
                                    plain: "",
                                    color: "#7232dd"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(selectItem.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled"]))
                            ]),
                            _: 2
                          }, 1032, ["name"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["name", "rules"])
              ]))
            }), 128)),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_van_field, {
                modelValue: _ctx.form.otherInfo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.otherInfo = $event)),
                name: "otherInfo",
                rows: "3",
                autosize: "",
                type: "textarea",
                maxlength: "1000",
                placeholder: "请输入您最近的身体状态，方便专家针对性分析",
                "show-word-limit": "",
                disabled: _ctx.onlyReadable
              }, null, 8, ["modelValue", "disabled"])
            ]),
            (!_ctx.onlyReadable)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode(_component_van_button, {
                    round: "",
                    block: "",
                    type: "primary",
                    "native-type": "submit",
                    color: "rgb(116, 83, 213)"
                  }, {
                    default: _withId(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
})